import { useQueryClient } from '@tanstack/react-query'

import {
  useIndividualsServicePostV1IndividualsByIndividualIdGenerateDescription,
} from '../client/queries'
import {
  useIndividualsServiceGetV1IndividualsByIndividualIdKey,
} from '../client/queries/common'

export const useGenerateIndividualDescription = () => {
  const queryClient = useQueryClient()

  return useIndividualsServicePostV1IndividualsByIndividualIdGenerateDescription({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useIndividualsServiceGetV1IndividualsByIndividualIdKey],
      })
    },
  })
}
